const routes = [
    // 数据中心
    {
        path: 'dataCenter',
        name: '数据中心',
        component: () => import('@/views/dataCenter/index'),
    },
]

export default routes